import { Component } from '@angular/core';
import { EAppNotificationType } from '@enums';
import { AppConfigService, AuthService } from '../../services';

/**
 * User Suspended Component
 * @export
 * @class UserSuspendedComponent
 * @typedef {UserSuspendedComponent}
 */
@Component({
  selector: 'aup-user-suspended',
  templateUrl: './user-suspended.component.html',
  styleUrls: ['./user-suspended.component.scss'],
  standalone: false,
})
export class UserSuspendedComponent {
  EAppNotificationType = EAppNotificationType;
  logoPath: string;
  pageTitle: string;

  constructor(
    public authService: AuthService,
    appConfigService: AppConfigService
  ) {
    const countryConfig = appConfigService.getCountryConfig();
    this.logoPath = countryConfig?.logoPath;
    this.pageTitle = countryConfig?.pageTitle;
  }
}
